var _style, _path, _path2, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag9Hi({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 42",
    style: {
      enableBackground: "new 0 0 64 42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF9933;}\n\t.st1{fill:#138808;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#000088;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_7_copy_1_",
    className: "st0",
    d: "M5.8,0h52.3C61.4,0,64,2.6,64,5.7v30.6c0,3.2-2.6,5.7-5.8,5.7H5.8 C2.6,42,0,39.4,0,36.3V5.7C0,2.6,2.6,0,5.8,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,36.3C0,39.4,2.6,42,5.8,42h52.4c3.2,0,5.8-2.5,5.8-5.7V14H0V36.3z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 14,
    className: "st2",
    width: 64,
    height: 14
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32,14.8c-3.5,0-6.2,2.8-6.2,6.2s2.8,6.2,6.2,6.2s6.2-2.8,6.2-6.2S35.5,14.8,32,14.8z M37.7,21.7 c0,0.1-0.2,0.3-0.3,0.2l0,0c-0.1,0.3-0.1,0.6-0.2,0.9l0,0c0.1,0.1,0.2,0.2,0.1,0.4c-0.1,0.1-0.2,0.2-0.4,0.1l0,0 c-0.1,0.3-0.3,0.5-0.4,0.8l0,0c0.1,0.1,0.1,0.3,0.1,0.4c-0.1,0.1-0.3,0.1-0.4,0.1l0,0c-0.1,0.1-0.2,0.2-0.3,0.3 c-0.1,0.1-0.2,0.2-0.3,0.3l0,0c0.1,0.1,0.1,0.3-0.1,0.4c-0.1,0.1-0.3,0.1-0.4-0.1l0,0c-0.2,0.2-0.5,0.3-0.8,0.4l0,0 c0.1,0.1,0,0.3-0.1,0.4s-0.3,0-0.4-0.1l0,0c-0.3,0.1-0.6,0.2-0.9,0.2l0,0c0,0.1-0.1,0.3-0.2,0.3c-0.1,0-0.3-0.1-0.3-0.2l0,0 c-0.1,0-0.3,0-0.4,0s-0.3,0-0.4,0l0,0c0,0.1-0.2,0.3-0.3,0.2c-0.1,0-0.3-0.2-0.2-0.3l0,0c-0.3-0.1-0.6-0.1-0.9-0.2l0,0 c-0.1,0.1-0.2,0.2-0.4,0.1c-0.1-0.1-0.2-0.2-0.1-0.4l0,0c-0.3-0.1-0.5-0.3-0.8-0.4l0,0c-0.1,0.1-0.3,0.1-0.4,0.1 c-0.1-0.1-0.1-0.3-0.1-0.4l0,0c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.1-0.2-0.2-0.3-0.3l0,0c-0.1,0.1-0.3,0.1-0.4-0.1 c-0.1-0.1-0.1-0.3,0.1-0.4l0,0c-0.2-0.2-0.3-0.5-0.4-0.8l0,0c-0.1,0.1-0.3,0-0.4-0.1s0-0.3,0.1-0.4l0,0c-0.1-0.3-0.2-0.6-0.2-0.9 l0,0c-0.1,0-0.3-0.1-0.3-0.2s0.1-0.3,0.2-0.3l0,0c0-0.1,0-0.3,0-0.4s0-0.3,0-0.4l0,0c-0.1,0-0.3-0.2-0.2-0.3c0-0.1,0.2-0.3,0.3-0.2 l0,0c0.1-0.3,0.1-0.6,0.2-0.9l0,0c-0.1-0.1-0.2-0.2-0.1-0.4c0.1-0.1,0.2-0.2,0.4-0.1l0,0c0.1-0.3,0.3-0.5,0.4-0.8l0,0 c-0.1-0.1-0.1-0.3-0.1-0.4c0.1-0.1,0.3-0.1,0.4-0.1l0,0c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.2-0.2,0.3-0.3l0,0 c-0.1-0.1-0.1-0.3,0.1-0.4c0.1-0.1,0.3-0.1,0.4,0.1l0,0c0.2-0.2,0.5-0.3,0.8-0.4l0,0c-0.1-0.1,0-0.3,0.1-0.4c0.1-0.1,0.3,0,0.4,0.1 l0,0c0.3-0.1,0.6-0.2,0.9-0.2l0,0c0-0.1,0.1-0.3,0.2-0.3s0.3,0.1,0.3,0.2l0,0c0.1,0,0.3,0,0.4,0s0.3,0,0.4,0l0,0 c0-0.1,0.2-0.3,0.3-0.2c0.1,0,0.3,0.2,0.2,0.3l0,0c0.3,0.1,0.6,0.1,0.9,0.2l0,0c0.1-0.1,0.2-0.2,0.4-0.1c0.1,0.1,0.2,0.2,0.1,0.4 l0,0c0.3,0.1,0.5,0.3,0.8,0.4l0,0c0.1-0.1,0.3-0.1,0.4-0.1c0.1,0.1,0.1,0.3,0.1,0.4l0,0c0.1,0.1,0.2,0.2,0.3,0.3 c0.1,0.1,0.2,0.2,0.3,0.3l0,0c0.1-0.1,0.3-0.1,0.4,0.1c0.1,0.1,0.1,0.3-0.1,0.4l0,0c0.2,0.2,0.3,0.5,0.4,0.8l0,0 c0.1-0.1,0.3,0,0.4,0.1c0.1,0.1,0,0.3-0.1,0.4l0,0c0.1,0.3,0.2,0.6,0.2,0.9l0,0c0.1,0,0.3,0.1,0.3,0.2s-0.1,0.3-0.2,0.3l0,0 c0,0.1,0,0.3,0,0.4s0,0.3,0,0.4l0,0C37.6,21.5,37.7,21.6,37.7,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M32.7,21.8l-0.1,0.1l0.7,0.9l1.5,2.9L32.9,23l-0.4-1c-0.1,0-0.1,0-0.2,0.1l0.4,1l0.7,3.2l-1-3.1l-0.2-1.1 c-0.1,0-0.1,0-0.2,0l0.1,1.1L32,26.5c0.1,0,0.3,0,0.4,0c0-0.1,0.1-0.3,0.2-0.3c0.1,0,0.3,0.1,0.3,0.2c0.3-0.1,0.6-0.1,0.9-0.2 c-0.1-0.1,0-0.3,0.1-0.4s0.3,0,0.4,0.1c0.3-0.1,0.5-0.3,0.8-0.4c-0.1-0.1-0.1-0.3,0.1-0.4c0.1-0.1,0.3-0.1,0.4,0 c0.1-0.1,0.2-0.2,0.3-0.3l-2.5-2.2L32.7,21.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M32.1,19.9c0.1,0,0.1,0,0.2,0l0.2-1.1l1-3.1l-0.7,3.2l-0.4,1c0.1,0,0.1,0,0.2,0.1l0.4-1l1.8-2.7l-1.5,2.9 l-0.7,0.9l0.1,0.1l0.7-0.9l2.5-2.2c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1,0.1-0.3,0.1-0.4,0c-0.1-0.1-0.1-0.3-0.1-0.4 c-0.2-0.2-0.5-0.3-0.8-0.4c-0.1,0.1-0.2,0.2-0.4,0.1c-0.1-0.1-0.2-0.2-0.1-0.4c-0.3-0.1-0.6-0.2-0.9-0.2c0,0.1-0.2,0.2-0.3,0.2 s-0.3-0.2-0.2-0.3c-0.1,0-0.3,0-0.4,0l0.2,3.3L32.1,19.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M31.2,21.7l-0.1-0.1l-0.9,0.7l-2.9,1.5L30,22l1-0.4c0-0.1,0-0.1-0.1-0.2l-1,0.4l-3.2,0.7l3.1-1l1.1-0.2 c0-0.1,0-0.1,0-0.2l-1.1,0.1L26.5,21c0,0.1,0,0.3,0,0.4c0.1,0,0.3,0.1,0.3,0.2s-0.1,0.3-0.2,0.3c0.1,0.3,0.1,0.6,0.2,0.9 c0.1-0.1,0.3,0,0.4,0.1s0,0.3-0.1,0.4c0.1,0.3,0.3,0.5,0.4,0.8c0.1-0.1,0.3-0.1,0.4,0.1c0.1,0.1,0.1,0.3,0,0.4 c0.1,0.1,0.2,0.2,0.3,0.3l2.2-2.5L31.2,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M31.9,22.1c-0.1,0-0.1,0-0.2,0l-0.2,1.1l-1,3.1l0.7-3.2l0.4-1c-0.1,0-0.1,0-0.2-0.1L31,23l-1.8,2.7l1.5-2.9 l0.7-0.9l-0.1-0.1l-0.7,0.9l-2.5,2.2c0.1,0.1,0.2,0.2,0.3,0.3c0.1-0.1,0.3-0.1,0.4,0s0.1,0.3,0.1,0.4c0.2,0.2,0.5,0.3,0.8,0.4 c0.1-0.1,0.2-0.2,0.4-0.1c0.1,0.1,0.2,0.2,0.1,0.4c0.3,0.1,0.6,0.2,0.9,0.2c0-0.1,0.2-0.2,0.3-0.2c0.1,0,0.3,0.2,0.2,0.3 c0.1,0,0.3,0,0.4,0l-0.2-3.3L31.9,22.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M31.3,20.2l0.1-0.1l-0.7-0.9l-1.5-2.9L31,19l0.4,1c0.1,0,0.1,0,0.2-0.1l-0.4-1l-0.7-3.2l1,3.1l0.2,1.1 c0.1,0,0.1,0,0.2,0l-0.1-1.1l0.2-3.3c-0.1,0-0.3,0-0.4,0c0,0.1-0.1,0.3-0.2,0.3s-0.3-0.1-0.3-0.2c-0.3,0.1-0.6,0.1-0.9,0.2 c0.1,0.1,0,0.3-0.1,0.4s-0.3,0-0.4-0.1c-0.3,0.1-0.5,0.3-0.8,0.4c0.1,0.1,0.1,0.3-0.1,0.4c-0.1,0.1-0.3,0.1-0.4,0 c-0.1,0.1-0.2,0.2-0.3,0.3l2.5,2.2L31.3,20.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M37.2,21.7c0-0.1,0.2-0.3,0.3-0.2c0-0.1,0-0.3,0-0.4l-3.3,0.2l-1.1-0.1c0,0.1,0,0.1,0,0.2l1.1,0.2l3.1,1 l-3.2-0.7l-1-0.4c0,0.1,0,0.1-0.1,0.2l1,0.4l2.7,1.8l-2.9-1.5l-0.9-0.7l-0.1,0.1l0.9,0.7l2.2,2.5c0.1-0.1,0.2-0.2,0.3-0.3 c-0.1-0.1-0.1-0.3,0-0.4s0.3-0.1,0.4-0.1c0.2-0.2,0.3-0.5,0.4-0.8c-0.1-0.1-0.2-0.2-0.1-0.4c0.1-0.1,0.2-0.2,0.4-0.1 c0.1-0.3,0.2-0.6,0.2-0.9C37.2,22,37.1,21.8,37.2,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M30.9,20.9c0-0.1,0-0.1,0-0.2l-1.1-0.2l-3.1-1l3.2,0.7l1,0.4c0-0.1,0-0.1,0.1-0.2L30,20l-2.7-1.8l2.9,1.5 l0.9,0.7l0.1-0.1l-0.9-0.7l-2.2-2.5c-0.1,0.1-0.2,0.2-0.3,0.3c0.1,0.1,0.1,0.3,0,0.4s-0.3,0.1-0.4,0.1c-0.2,0.2-0.3,0.5-0.4,0.8 c0.1,0.1,0.2,0.2,0.1,0.4c-0.1,0.1-0.2,0.2-0.4,0.1c-0.1,0.3-0.2,0.6-0.2,0.9c0.1,0,0.2,0.2,0.2,0.3c0,0.1-0.2,0.3-0.3,0.2 c0,0.1,0,0.3,0,0.4l3.3-0.2L30.9,20.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M32.8,20.3l0.1,0.1l0.9-0.7l2.9-1.5L34,20.1l-1,0.4c0,0.1,0,0.1,0.1,0.2l1-0.4l3.2-0.7l-3.1,1l-1.1,0.2 c0,0.1,0,0.1,0,0.2l1.1-0.1l3.3,0.2c0-0.1,0-0.3,0-0.4c-0.1,0-0.3-0.1-0.3-0.2s0.1-0.3,0.2-0.3c-0.1-0.3-0.1-0.6-0.2-0.9 c-0.1,0.1-0.3,0-0.4-0.1c-0.1-0.1,0-0.3,0.1-0.4c-0.1-0.3-0.3-0.5-0.4-0.8c-0.1,0.1-0.3,0.1-0.4-0.1c-0.1-0.1-0.1-0.3,0-0.4 c-0.1-0.1-0.2-0.2-0.3-0.3l-2.2,2.5L32.8,20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M33.1,20.9c0-0.1,0-0.1,0-0.2l-0.5,0.1l0.4-0.2c0-0.1,0-0.1-0.1-0.2l-0.4,0.2l0.4-0.3l-0.1-0.1l-0.4,0.3 l0.3-0.4L32.6,20l-0.3,0.4l0.2-0.4c-0.1,0-0.1,0-0.2-0.1l-0.2,0.4l0.1-0.5c-0.1,0-0.1,0-0.2,0v0.6l-0.1-0.5c-0.1,0-0.1,0-0.2,0 l0.1,0.5L31.7,20c-0.1,0-0.1,0-0.2,0.1l0.2,0.4l-0.3-0.4l-0.1,0.1l0.3,0.4l-0.4-0.3l-0.1,0.1l0.4,0.3L31,20.5c0,0.1,0,0.1-0.1,0.2 l0.4,0.2l-0.5-0.1c0,0.1,0,0.1,0,0.2l0.5,0.1l-0.5,0.1c0,0.1,0,0.1,0,0.2l0.5-0.1l-0.3,0c0,0.1,0,0.1,0.1,0.2l0.4-0.2l-0.4,0.3 l0.1,0.1l0.4-0.3l-0.3,0.4l0.1,0.1l0.3-0.4L31.5,22c0.1,0,0.1,0,0.2,0.1l0.2-0.4l-0.1,0.5c0.1,0,0.1,0,0.2,0l0.1-0.5l0.1,0.5 c0.1,0,0.1,0,0.2,0l-0.1-0.5l0.2,0.4c0.1,0,0.1,0,0.2-0.1l-0.2-0.4l0.3,0.4l0.1-0.1l-0.3-0.4l0.4,0.3l0.1-0.1l-0.4-0.3l0.4,0.2 c0-0.1,0-0.1,0.1-0.2l-0.4-0.2l0.5,0.1c0-0.1,0-0.1,0-0.2L32.6,21L33.1,20.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M37.5,21.4L37.5,21.4c0,0.2,0,0.4-0.1,0.5l0,0c0.1,0,0.3-0.1,0.3-0.2C37.7,21.6,37.6,21.5,37.5,21.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M37.2,21.7c0,0.1,0.1,0.3,0.2,0.3c0-0.2,0.1-0.4,0.1-0.5C37.3,21.4,37.2,21.5,37.2,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.1,22.1C32,22.1,32,22.1,32.1,22.1c-0.1,0-0.1,0-0.1,0l-0.1,1.1l0.2,3.3l0.2-3.3L32.1,22.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31.9,22.1C32,22.1,32,22.1,31.9,22.1c0.1,0,0.1,0,0.1,0v-0.5L31.9,22.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M36.9,23.3c0.1,0.1,0.3,0,0.4-0.1c0.1-0.1,0-0.3-0.1-0.4l0,0C37.1,23,37,23.2,36.9,23.3L36.9,23.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M36.8,23c-0.1,0.1,0,0.3,0.1,0.4c0.1-0.2,0.1-0.3,0.2-0.5C37,22.8,36.9,22.9,36.8,23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31.3,23.1l-0.7,3.2l1-3.1l0.2-1.1h-0.1L31.3,23.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31.7,22h0.1l0.1-0.5L31.7,22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M36.2,24.5c0.1,0.1,0.3,0.1,0.4-0.1c0.1-0.1,0.1-0.3-0.1-0.4l0,0C36.4,24.3,36.3,24.4,36.2,24.5L36.2,24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M36.1,24.2c-0.1,0.1-0.1,0.3,0,0.4c0.1-0.1,0.2-0.3,0.3-0.4C36.4,24,36.2,24,36.1,24.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.7,22.8l-1.5,2.9L31,23l0.4-1c0,0-0.1,0-0.1-0.1L30.7,22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31.4,21.9C31.4,21.9,31.5,22,31.4,21.9l0.3-0.4L31.4,21.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M35.1,25.5c0.1,0.1,0.3,0.1,0.4,0.1c0.1-0.1,0.1-0.3,0.1-0.4l0,0C35.4,25.3,35.3,25.4,35.1,25.5L35.1,25.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M35.2,25.1c-0.1,0.1-0.1,0.3-0.1,0.4c0.1-0.1,0.3-0.2,0.4-0.3C35.4,25.1,35.3,25,35.2,25.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31.3,21.8C31.2,21.8,31.2,21.8,31.3,21.8l-0.9,0.6l-2.2,2.5l2.5-2.2L31.3,21.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31.2,21.7C31.2,21.8,31.2,21.8,31.2,21.7l0.4-0.3L31.2,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M33.8,26.2c0.1,0.1,0.2,0.2,0.4,0.1c0.1-0.1,0.2-0.2,0.1-0.4l0,0C34.2,26,34,26.1,33.8,26.2L33.8,26.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M34,25.8c-0.1,0.1-0.2,0.2-0.1,0.4c0.2-0.1,0.3-0.1,0.5-0.2C34.3,25.8,34.1,25.7,34,25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30,21.9l-2.7,1.8l2.9-1.5l0.9-0.7c0,0,0-0.1-0.1-0.1L30,21.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31,21.5C31,21.5,31.1,21.6,31,21.5l0.4-0.2L31,21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.4,26.5c0,0.1,0.2,0.3,0.3,0.2c0.1,0,0.3-0.2,0.2-0.3l0,0C32.8,26.4,32.6,26.4,32.4,26.5L32.4,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.7,26.2c-0.1,0-0.3,0.2-0.2,0.3c0.2,0,0.4,0,0.5-0.1C33,26.2,32.8,26.1,32.7,26.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M29.8,21.4l-3.1,1l3.2-0.7l1-0.4v-0.1L29.8,21.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.9,21.2v0.1l0.4-0.2L30.9,21.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31,26.4c0,0.1,0.1,0.3,0.2,0.3s0.3-0.1,0.3-0.2l0,0C31.4,26.4,31.2,26.4,31,26.4L31,26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31.3,26.2c-0.1,0-0.3,0.1-0.3,0.2c0.2,0,0.4,0.1,0.5,0.1C31.6,26.3,31.5,26.2,31.3,26.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.9,21.1C30.9,21,30.9,21,30.9,21.1c0-0.1,0-0.1,0-0.1l-1.1-0.1L26.5,21l3.3,0.2L30.9,21.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.9,20.9C30.9,21,30.9,21,30.9,20.9c0,0.1,0,0.1,0,0.1l0.5-0.1H30.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M29.7,25.9c-0.1,0.1,0,0.3,0.1,0.4s0.3,0,0.4-0.1l0,0C30,26.1,29.8,26,29.7,25.9L29.7,25.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30,25.8c-0.1-0.1-0.3,0-0.4,0.1c0.2,0.1,0.3,0.1,0.5,0.2C30.2,26,30.1,25.9,30,25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M29.9,20.3l-3.2-0.7l3.1,1l1.1,0.2v-0.1L29.9,20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31,20.7v0.1l0.5,0.1L31,20.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M28.5,25.2c-0.1,0.1-0.1,0.3,0.1,0.4c0.1,0.1,0.3,0.1,0.4-0.1l0,0C28.7,25.4,28.6,25.3,28.5,25.2L28.5,25.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M28.8,25.1c-0.1-0.1-0.3-0.1-0.4,0c0.1,0.1,0.3,0.2,0.4,0.3C29,25.4,29,25.2,28.8,25.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.2,19.7l-2.9-1.5L30,20l1,0.4c0,0,0-0.1,0.1-0.1L30.2,19.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31.1,20.4C31.1,20.4,31,20.5,31.1,20.4l0.4,0.3L31.1,20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M27.5,24.1c-0.1,0.1-0.1,0.3-0.1,0.4c0.1,0.1,0.3,0.1,0.4,0.1l0,0C27.7,24.4,27.6,24.3,27.5,24.1L27.5,24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M27.9,24.2c-0.1-0.1-0.3-0.1-0.4-0.1c0.1,0.1,0.2,0.3,0.3,0.4C27.9,24.4,28,24.3,27.9,24.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31.2,20.3C31.2,20.2,31.2,20.2,31.2,20.3l-0.6-0.9l-2.5-2.2l2.2,2.5L31.2,20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31.3,20.2C31.2,20.2,31.2,20.2,31.3,20.2l0.3,0.4L31.3,20.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M26.8,22.8c-0.1,0.1-0.2,0.2-0.1,0.4c0.1,0.1,0.2,0.2,0.4,0.1l0,0C27,23.2,26.9,23,26.8,22.8L26.8,22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M27.2,23c-0.1-0.1-0.2-0.2-0.4-0.1c0.1,0.2,0.1,0.3,0.2,0.5C27.2,23.3,27.3,23.1,27.2,23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31.1,19l-1.8-2.7l1.5,2.9l0.7,0.9c0,0,0.1,0,0.1-0.1L31.1,19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31.5,20C31.5,20,31.4,20.1,31.5,20l0.2,0.4L31.5,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M26.5,21.4c-0.1,0-0.3,0.2-0.2,0.3c0,0.1,0.2,0.3,0.3,0.2l0,0C26.6,21.8,26.6,21.6,26.5,21.4L26.5,21.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M26.8,21.7c0-0.1-0.2-0.3-0.3-0.2c0,0.2,0,0.4,0.1,0.5C26.8,22,26.9,21.8,26.8,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31.6,18.8l-1-3.1l0.7,3.2l0.4,1h0.1L31.6,18.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31.8,19.9h-0.1l0.2,0.4L31.8,19.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M26.6,20c-0.1,0-0.3,0.1-0.3,0.2s0.1,0.3,0.2,0.3l0,0C26.6,20.4,26.6,20.2,26.6,20L26.6,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M26.8,20.3c0-0.1-0.1-0.3-0.2-0.3c0,0.2-0.1,0.4-0.1,0.5C26.7,20.6,26.8,20.5,26.8,20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31.9,19.9C32,19.9,32,19.9,31.9,19.9c0.1,0,0.1,0,0.1,0l0.1-1.1L32,15.5l-0.2,3.3L31.9,19.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.1,19.9C32,19.9,32,19.9,32.1,19.9c-0.1,0-0.1,0-0.1,0l0.1,0.5V19.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M27.1,18.7c-0.1-0.1-0.3,0-0.4,0.1s0,0.3,0.1,0.4l0,0C26.9,19,27,18.8,27.1,18.7L27.1,18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M27.2,19c0.1-0.1,0-0.3-0.1-0.4c-0.1,0.2-0.1,0.3-0.2,0.5C27,19.2,27.1,19.1,27.2,19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.7,18.9l0.7-3.2l-1,3.1l-0.2,1.1h0.1L32.7,18.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.3,20L32.3,20l-0.2,0.5L32.3,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M27.8,17.5c-0.1-0.1-0.3-0.1-0.4,0.1c-0.1,0.1-0.1,0.3,0.1,0.4l0,0C27.6,17.7,27.7,17.6,27.8,17.5L27.8,17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M27.9,17.8c0.1-0.1,0.1-0.3,0-0.4c-0.1,0.1-0.2,0.3-0.3,0.4C27.6,18,27.8,18,27.9,17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M33.3,19.2l1.5-2.9L32.9,19l-0.4,1c0,0,0.1,0,0.1,0.1L33.3,19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.6,20.1C32.6,20.1,32.5,20,32.6,20.1l-0.3,0.4L32.6,20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M28.9,16.5c-0.1-0.1-0.3-0.1-0.4-0.1c-0.1,0.1-0.1,0.3-0.1,0.4l0,0C28.6,16.7,28.7,16.6,28.9,16.5L28.9,16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M28.8,16.9c0.1-0.1,0.1-0.3,0.1-0.4c-0.1,0.1-0.3,0.2-0.4,0.3C28.6,16.9,28.7,17,28.8,16.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.7,20.2C32.8,20.2,32.8,20.2,32.7,20.2l0.9-0.6l2.2-2.5l-2.5,2.2L32.7,20.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.8,20.3C32.8,20.2,32.8,20.2,32.8,20.3l-0.4,0.3L32.8,20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.2,15.8c-0.1-0.1-0.2-0.2-0.4-0.1c-0.1,0.1-0.2,0.2-0.1,0.4l0,0C29.8,16,30,15.9,30.2,15.8L30.2,15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30,16.2c0.1-0.1,0.2-0.2,0.1-0.4c-0.2,0.1-0.3,0.1-0.5,0.2C29.7,16.2,29.9,16.3,30,16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M34,20.1l2.7-1.8l-2.9,1.5l-0.9,0.7c0,0,0,0.1,0.1,0.1L34,20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M33,20.5C33,20.5,32.9,20.4,33,20.5l-0.4,0.2L33,20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31.6,15.5c0-0.1-0.2-0.3-0.3-0.2c-0.1,0-0.3,0.2-0.2,0.3l0,0C31.2,15.6,31.4,15.6,31.6,15.5L31.6,15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31.3,15.8c0.1,0,0.3-0.2,0.2-0.3c-0.2,0-0.4,0-0.5,0.1C31,15.8,31.2,15.9,31.3,15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M34.2,20.6l3.1-1l-3.2,0.7l-1,0.4v0.1L34.2,20.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M33.1,20.8v-0.1l-0.4,0.2L33.1,20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M33,15.6c0-0.1-0.1-0.3-0.2-0.3c-0.1,0-0.3,0.1-0.3,0.2l0,0C32.6,15.6,32.8,15.6,33,15.6L33,15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.7,15.8c0.1,0,0.3-0.1,0.3-0.2c-0.2,0-0.4-0.1-0.5-0.1C32.4,15.7,32.5,15.8,32.7,15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M33.1,20.9C33.1,21,33.1,21,33.1,20.9c0,0.1,0,0.1,0,0.1l1.1,0.1l3.3-0.2l-3.3-0.2L33.1,20.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M33.1,20.9L32.6,21l0.5,0.1C33.1,21,33.1,21,33.1,20.9C33.1,21,33.1,21,33.1,20.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M34.3,16.1c0.1-0.1,0-0.3-0.1-0.4c-0.1-0.1-0.3,0-0.4,0.1l0,0C34,15.9,34.2,16,34.3,16.1L34.3,16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M34,16.2c0.1,0.1,0.3,0,0.4-0.1c-0.2-0.1-0.3-0.1-0.5-0.2C33.8,16,33.9,16.1,34,16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M34.1,21.7l3.2,0.7l-3.1-1l-1.1-0.2v0.1L34.1,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M33,21.3v-0.1l-0.5-0.1L33,21.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M35.5,16.8c0.1-0.1,0.1-0.3-0.1-0.4c-0.1-0.1-0.3-0.1-0.4,0.1l0,0C35.3,16.6,35.4,16.7,35.5,16.8L35.5,16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M35.2,16.9c0.1,0.1,0.3,0.1,0.4,0c-0.1-0.1-0.3-0.2-0.4-0.3C35,16.6,35,16.8,35.2,16.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M33.8,22.3l2.9,1.5L34,21.9l-1-0.4c0,0,0,0.1-0.1,0.1L33.8,22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.9,21.6C32.9,21.6,33,21.5,32.9,21.6l-0.4-0.3L32.9,21.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M36.5,17.9c0.1-0.1,0.1-0.3,0.1-0.4c-0.1-0.1-0.3-0.1-0.4-0.1l0,0C36.3,17.6,36.4,17.7,36.5,17.9L36.5,17.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M36.1,17.8c0.1,0.1,0.3,0.1,0.4,0.1c-0.1-0.1-0.2-0.3-0.3-0.4C36.1,17.6,36,17.7,36.1,17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.8,21.7C32.8,21.8,32.8,21.8,32.8,21.7l0.6,0.9l2.5,2.2l-2.2-2.5L32.8,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.7,21.8C32.8,21.8,32.8,21.8,32.7,21.8l-0.3-0.4L32.7,21.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M37.2,19.2c0.1-0.1,0.2-0.2,0.1-0.4c-0.1-0.1-0.2-0.2-0.4-0.1l0,0C37,18.8,37.1,19,37.2,19.2L37.2,19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M36.8,19c0.1,0.1,0.2,0.2,0.4,0.1c-0.1-0.2-0.1-0.3-0.2-0.5C36.8,18.7,36.7,18.9,36.8,19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.9,23l1.8,2.7l-1.5-2.9l-0.7-0.9c0,0-0.1,0-0.1,0.1L32.9,23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.5,22C32.5,22,32.6,21.9,32.5,22l-0.2-0.4L32.5,22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M37.5,20.6c0.1,0,0.3-0.2,0.2-0.3c0-0.1-0.2-0.3-0.3-0.2l0,0C37.4,20.2,37.4,20.4,37.5,20.6L37.5,20.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M37.2,20.3c0,0.1,0.2,0.3,0.3,0.2c0-0.2,0-0.4-0.1-0.5C37.2,20,37.1,20.2,37.2,20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.4,23.2l1,3.1l-0.7-3.2l-0.4-1h-0.1L32.4,23.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.2,22.1L32.2,22.1l-0.1-0.4L32.2,22.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag9Hi);
export default __webpack_public_path__ + "static/media/flag_9_HI.d5db7edabbb54ec040193f7e36e5a89b.svg";
export { ForwardRef as ReactComponent };